// src/modules/app-views/_apps/appmulti/receivables/pages/Init/components/tableColumns/dueDateColumn.js
import dayjs from 'dayjs';
import translateX from 'utils/translateX';

function dueDateColumn(buildColumnProps, options = {}) {
  const {
    key = 'dueDate',
    title = 'due_date',
    dataIndex = 'dueDate',
    width = 120,
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...(width && { width }),
    ...buildColumnProps(dataIndex, columnProps),
    align: 'center',
    render: value => {
      if (!value) return <span className="text-muted">—</span>;
      return dayjs(value).format('L');
    },
  };
}

export default dueDateColumn;
